import * as UserType from '../types/user.types';
import store from '@/core/store/index';

const fb = require('../../config/firebase.js');

const module = {
  namespaced: true,
  state: {
    currentUser: 'verifying',
    userProfile: 'verifying',
    users: [],
    c: undefined,
  },
  getters: {
    getCurrentUser(state) {
      return state.currentUser;
    },
    getUserProfile(state) {
      return state.userProfile;
    },
    isLoggedIn(state) {
      return state.currentUser && state.currentUser !== 'verifying';
    }
  },
  mutations: {
    [UserType.LOGIN_REQUEST](state) {
      state.currentUser = 'verifying';
      state.userProfile = 'verifying';
    },
    [UserType.LOGIN_SUCCESS](state, { user, profile }) {
      state.currentUser = user;
      state.userProfile = profile;
    },
    [UserType.LOGIN_FAILURE](state) {
      state.currentUser = undefined;
      state.userProfile = undefined;
      state.initializeAuth = undefined;
    },
    [UserType.SET_AUTH_PROMISE](state, payload) {
      state.initializeAuth = payload;
    },
    [UserType.LOGOUT_SUCCESS](state) {
      state.currentUser = undefined;
      state.userProfile = 'verifying';
      state.initializeAuth = undefined;
      state.users = [];
    },
    [UserType.UPDATE_PROFILE](state, payload) {
      state.userProfile = payload;
    },
    [UserType.ADD_USER](state, doc) {
      const data = doc.data();
      data.id = doc.id;
      state.users[doc.id] = data;
    },
  },
  actions: {
    async loadUserProfile ({ commit, state }, user) {
      // on snapshot will also update every time on any change
      if (state.userProfileListener) {
        state.userProfileListener();
      }

      if (!user) {
        commit(UserType.LOGIN_FAILURE);
        return;
      }

      state.userProfileListener = fb.usersCollection
        .doc(user.uid)
        .onSnapshot((res) => {
          commit(UserType.LOGIN_SUCCESS, { user, profile: res.data()});
        });
    },
    async logout({ commit }) {
      try {
        await fb.auth.signOut();
        await store.commit('events/CLEAR_EVENTS');
        commit(UserType.LOGOUT_SUCCESS);
      } catch (error) {
        console.error(error);
      }
    },
    async signInWithEmailAndPassword({ commit }, info) {
      try {
        commit(UserType.LOGIN_REQUEST);
        // Other info will be pulled by the onAuthStateChanged defined in the store index
        const user = await fb.auth.signInWithEmailAndPassword(info.email, info.password);
        return user;
      } catch (error) {
        commit(UserType.LOGIN_FAILURE);
        throw error;
      }
    },
    async waitForProfile( { state }) {
      if(state.currentUser === 'verifying' && state.initializeAuth)
        await state.initializeAuth;
    },
    async getUser({ state }, userId){
      return state.users[userId];
    },
    async pullUser({ state, commit }, userId) {
      try {
        const doc = await fb.usersCollection.doc(userId).get();
        if(doc.exists)
          commit(UserType.ADD_USER, doc);
      } catch (err) {

      }

      return state.users[userId];
    }
  },
};
export default module;
